module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/stacked-1-cde3958368f8defc4c73b18b2f5f8907.png";